import type {ContractParent} from "./contractCoverageData";
import {COVERAGE_CURRENCY} from "./contractCoverageData";
import {actionForPosition, POSITION_LABEL} from "./contractCoverageUtils";

const HEADERS = [
    'Parent supplier', 'Supplier', 'Country', 'Currency', 'Spend', 'Contract position',
    'Contracted value', 'Utilisation %', 'Cost saving', 'Cost avoidance', 'Contracts',
    'Next expiration', 'Recommended action',
];

function escapeCsv(value: string | number): string {
    const s = String(value);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** One row per child supplier, grouped under its parent. */
export function exportContractCoverageCsv(rows: ContractParent[], fileName = 'contract-coverage-intelligence'): void {
    const lines = [HEADERS.join(',')];
    for (const p of rows) {
        for (const ch of p.children) {
            lines.push([
                p.name,
                ch.supplier,
                ch.country ?? '',
                COVERAGE_CURRENCY,
                ch.spend,
                POSITION_LABEL[ch.position],
                ch.contractedValueEur > 0 ? ch.contractedValueEur : '',
                ch.contractedValueEur > 0 ? ch.utilizationPct : '',
                ch.costSavingEur || '',
                ch.costAvoidanceEur || '',
                ch.contractCount,
                ch.nextExpiration ?? '',
                actionForPosition(ch.position),
            ].map(escapeCsv).join(','));
        }
    }

    const blob = new Blob([lines.join('\n')], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
